module.exports = __webpack_public_path__ + "img/hero-presents-collage.b6e8e123.png";